import type { QueryClientConfig } from "@tanstack/react-query";

const MS_PER_MINUTE = 60_000;

export const toMinutes = (minutes: number): number => minutes * MS_PER_MINUTE;

/**
 * Shared `QueryClient` defaults for portal apps. Pass to `new QueryClient(...)`
 * so every app gets the same baseline instead of the bare library defaults.
 *
 * Queries do not retry: everything that reaches React Query as an error is a
 * real failure (4xx, a failed response-schema validation, or a 5xx/network
 * blip). Retrying deterministic errors only delays the error UI, and the few
 * queries that genuinely benefit from a retry opt in locally with their own
 * `retry` option. Mutations already default to no retries.
 */
export const defaultQueryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
};
